/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {SettingStateInterface} from '@/store/modules/settings/types';
import {Vue} from 'vue-property-decorator';

/**
 * Actions file for application settings operations.
 *
 * Actions are functions that can be exported and called upon potentially in an asynchronous manner.
 * To add an action export a named const function. e.g. export const fnName = ({ commit }, {id, name}) => { ... }
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const actions: ActionTree<SettingStateInterface, RootState> = {
    /**
     * Update settings media.
     *
     * @param {any} commit
     * @param {string} media
     */
    updateMedia({commit}: {commit: any}, media: string[]): void {
        commit('updateMedia', media);
    },

    /**
     * Update language settings.
     *
     * @param {any} commit
     * @param {string} language
     */
    updateLanguage({commit}: {commit: any}, language: string): void {
        commit('updateLanguage', language);
    },

    /**
     * Cookie consent given.
     *
     * @param {any} commit
     */
    consentGiven({commit}: {commit: any}): void {
        commit('updateConsent', true);

        if (undefined !== Vue.$ga) {
            Vue.$ga.enable();
        }
    },

    /**
     * Page Title
     *
     * @param {any} commit
     * @param {string} newTitle
     */
    updatePageTitle({commit}: {commit: any}, newTitle: string): void {
        commit('updatePageTitle', newTitle);
    },

    /**
     * Masthead image.
     *
     * @param {any} commit
     * @param {string | undefined} imageSlug
     */
    updateMastheadImage({commit}: {commit: any}, imageSlug: string | undefined): void {
        commit('updateMastheadImage', imageSlug);
    },

    /**
     * Background image.
     *
     * @param {any} commit
     * @param {string | undefined} imageSlug
     */
    updateBackgroundImage({commit}: {commit: any}, imageSlug: string | undefined): void {
        commit('updateBackgroundImage', imageSlug);
    },

};
